import { Spin, Timeline } from 'antd'
import { retrieveUPSTracking } from '../../api/artistSaleReports'
import {useEffect, useState} from 'react'

export default (props) => {
  const [status, setStatus] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(()=>{
    if (props.num && props.num !== 'test') {
      setLoading(true)
      retrieveUPSTracking(props.num).then((response) => {
        const track_data = response.data
        if (track_data.constructor === Array) {
          setStatus(track_data)
        }
      }).finally(()=>{
        setLoading(false)
      })
    }
  }, [props.num])

  return (
    <Spin size='small' spinning={loading}>
      <Timeline>
        {status?.map((data, index) => (
          <Timeline.Item key={index}>
            {data.date} {data.status}
          </Timeline.Item>
        ))}
      </Timeline>
    </Spin>
  )
}
